// src/components/HomePage/Section1/styles.js
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 100vh;
  background-color: #F5F5F5;
  padding: 0 5rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 2rem;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 60%;

  @media (max-width: 1024px) {
    max-width: 100%;
    align-items: center;
    text-align: center;
  }
`;

export const Title = styled.h1`
  color: #272643;
  font-size: 2.82rem;
  margin-bottom: 1rem;
  line-height: 1.2;
  text-align: left;
  @media (max-width: 1024px) {
    font-size: 2.2rem;
  }
`;


export const Subtitle = styled.p`
  color: #4D4D4D;
  font-size: 1.1rem;
  margin-bottom: 2rem;
  max-width: 90%;
  text-align: left;

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const ButtonPrimary = styled.button`
  background-color: #2563EB;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1c51c7;
  }
`;

export const ButtonSecondary = styled.button`
  background-color: white;
  color: #2563EB;
  border: 2px solid #2563EB;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: #2563EB;
    color: white;
  }
`;

export const RatingSection = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 75%;
`;

export const RatingStars = styled.div`
  color: #FFD700;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
`;

export const RatingText = styled.p`
  color: #4D4D4D;
  font-size: 0.9rem;
    text-align: left;
`;

export const ImageFrame = styled.img`
  max-width: 45%;
  height: auto;
  object-fit: contain;
  margin-top: 120px;
  
  @media (max-width: 1024px) {
    max-width: 100%;
    margin-top: 60px;
  }
  
  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 60px;
  }
`;

export const RotatedFlag = styled.img`
  max-width: 6%;
  height: auto;
  object-fit: contain;
  transform: rotate(-30deg);
  vertical-align: bottom;
  
  @media (max-width: 1024px) {
    max-width: 5%; 
  }
  
  @media (max-width: 768px) {
    max-width: 8%;
  }
  
  @media (max-width: 480px) {
    max-width: 12%;
  }
`;
